import React, { ReactNode } from 'react';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import useWindowDimensions from 'hooks/window-dimensions';
import defaultTheme from 'styles/theme';

import { featuresCards } from '@static-files/features-cards';

import ArrowButton, { ArrowButtonColor } from 'components/ArrowButton';
import Spacer from 'components/Spacer';
import FeatureCard from 'components/FeatureCard';

import Text, { TextStyleType, TextAlign } from 'components/Text';

import { HOMEPAGE_SCREENS } from 'routes/screen-definitions';

import * as S from './styles';

function WhatWeDo() {
  const navigate = useNavigate();
  const { t: translator } = useTranslation();

  const { width } = useWindowDimensions();
  const { mobile } = defaultTheme.screensSize;

  const featureCards: ReactNode[] = featuresCards.map((item, index) => {
    return <FeatureCard key={index} title={item.title} subTitle={item.subtitle} image={item.image} alt={item.alt} />;
  });

  return (
    <S.Container>
      <Spacer height={width < mobile ? 40 : 80} />

      <Text type={TextStyleType.SectionTitle}>{translator('home.whatWeDo.title')}</Text>

      <S.SubtitleContainer>
        <Text
          type={TextStyleType.BodyParagraph}
          color={defaultTheme.palette.secondary.main}
          textAlign={width < mobile ? TextAlign.Start : TextAlign.Center}
        >
          {translator('home.whatWeDo.text')}
        </Text>
      </S.SubtitleContainer>

      <Spacer height={width < mobile ? 20 : 40} />

      <S.Content>{featureCards}</S.Content>

      <Spacer height={width < mobile ? 20 : 40} />

      <ArrowButton
        label={translator('home.whatWeDo.buttonLabel')}
        color={ArrowButtonColor.Blue}
        onPressed={() => navigate(`${HOMEPAGE_SCREENS.home}${HOMEPAGE_SCREENS.services}`)}
      />

      <Spacer height={width < mobile ? 40 : 80} />
    </S.Container>
  );
}

export default WhatWeDo;
